import { WarningOutlined } from '@ant-design/icons'
import { Row, Form, Input, Radio, Space, Typography, Button } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/AuthProvider'
import { InfoModal } from '../common'

const AuthorName = ({
  type,
  firstName,
  lastName,
  onSubmit,
  onAuthorChange,
}) => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [form] = Form.useForm()

  const { Paragraph } = Typography

  useEffect(() => {
    if (type === 2) {
      form.setFieldsValue({
        type: type,
        firstname: firstName,
        lastname: lastName,
      })
    }
  }, [type])

  return (
    <Form
      onFinish={onSubmit}
      onFieldsChange={onAuthorChange}
      layout="vertical"
      className="author-name"
      form={form}
    >
      <Form.Item name="type" initialValue={type}>
        <Radio.Group value={type}>
          <Space direction="vertical">
            <Radio value={1}>
              <Row justify={'space-between'}>
                <Paragraph className="paragraph-s">
                  {t('Author.RealName')}
                </Paragraph>
                <InfoModal info={t('Author.RealName.info')} />
              </Row>
              <Paragraph className="content paragraph-sb">{user}</Paragraph>
            </Radio>
            <Radio value={2}>
              <Row justify={'space-between'}>
                <Paragraph className="paragraph-s">
                  {t('Author.Pseudonym')}
                </Paragraph>
                <InfoModal title={t('Author.Pseudonym.info1')}>
                  {t('Author.Pseudonym.info2')}
                  <br />
                  <ul>
                    <li>{t('Author.Pseudonym.info3')}</li>
                    <li>{t('Author.Pseudonym.info4')}</li>
                  </ul>
                  <WarningOutlined /> {t('Author.Pseudonym.info5')}
                </InfoModal>
              </Row>
              <Row className="content" style={{ marginLeft: '-28px' }}>
                <Form.Item
                  label={t('Author.Pseudonym.FirstName')}
                  name="firstname"
                  initialValue={type === 2 ? firstName : ''}
                  rules={[
                    {
                      required: type === 2,
                      message: t('Register.error.PleaseEnterFirstName'),
                    },
                  ]}
                  style={{ paddingRight: '15px' }}
                >
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item
                  label={t('Author.Pseudonym.LastName')}
                  name="lastname"
                  initialValue={type === 2 ? lastName : ''}
                  rules={[
                    {
                      required: type === 2,
                      message: t('Register.error.PleaseEnterLastName'),
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
              </Row>
            </Radio>
            <Radio value={3}>
              <Row justify={'space-between'}>
                <Paragraph className="paragraph-s">
                  {t('Author.Anonymous')}
                </Paragraph>
                <InfoModal info={t('Author.Anonymous.info')} />
              </Row>
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <br />
      <br />
      <Paragraph className="paragraph-sb mb0">
        {t('Author.ContinueToDetails')}
      </Paragraph>
      <Button type="primary" htmlType="submit">
        {t('Author.Continue.button')}
      </Button>
    </Form>
  )
}

export default AuthorName
